import React, { useEffect, useState } from 'react';
import genStyles from './generale.module.css';
import ResultForm from './resultat/resultatForm';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { currentPageEntityFileAtom, entiteFileState, messageAfficheState, searchQueryEntityFileAtom, showResultFormState, sortConfigEntityFileAtom, statusOpenentiteFileState } from '../atoms/GeocoderState';
import TooltipForm from './tooltipForm';
import SetStyleForm from './setStyleForm';
import DrawService from '../service/DrawService';
import ShowService from '../service/showService';
import FullScreenModal from './utilsForm/fullScreenModal';
import DeleteCollectionForm from './deleteCollectionForm';

export default function GeocoderResult({onValidateEntite,onReloaEntite}) {
   
    const [entitesFile, setEntitesFile] = useRecoilState(entiteFileState);
    const [selectedRows, setSelectedRows] = useState([]);  
    const [allOpen, setAllOpen] = useState(true); 
    const [isVisible, setIsVisible] = useState(false); 
    const [openFilesStates, setOpenFilesStates] = useRecoilState(statusOpenentiteFileState);
    const [sortConfigEntityFile, setSortConfigEntityFile] = useRecoilState(sortConfigEntityFileAtom);
    const [searchQueryEntityFile, setSearchQueryEntityFile] = useRecoilState(searchQueryEntityFileAtom);
    const [currentPageEntityFile, setCurrentPageEntityFile] = useRecoilState(currentPageEntityFileAtom);   
    const [objetCur, setObjetCur] = useState({});
    const [showStyleForm, setShowStyleForm] = useState(false);
    const [popoverStyle, setPopoverStyle] = useState({ top: 0, left: 0 });
    const [showConfirmModalDeleteAll, setShowConfirmModalDeleteAll] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const setActiveTab = useSetRecoilState(showResultFormState);
    const messageAffiche = useRecoilValue(messageAfficheState);
    
    const allChecked = selectedRows.length === entitesFile.length && entitesFile.length > 0;
    const typeFR = {
        textMarker: { img: <i className={`fa-solid fa-text ${genStyles.fontSize20}`}></i> },
        marker: { img: <i className={`fa-solid fa-location-dot ${genStyles.fontSize20}`}></i> },
        circle: { img: <i className={`fa-solid fa-circle ${genStyles.fontSize20}`}></i> },
        polyline: { img: <i className={`fa-kit fa-draw-polyline-icon ${genStyles.fontSize20}`}></i> },
        polygon: { img: <i className={`fa-solid fa-vector-polygon ${genStyles.fontSize20}`}></i> },
        rectangle: { img: <i className={`fa-solid fa-vector-square ${genStyles.fontSize20}`}></i> },
    };
    
    useEffect(() => {
        if (onReloaEntite) {
            onReloaEntite(entitesFile);
        }
    }, [entitesFile]);

    const selectAllDataRow = (row) => {
        const id = row.id;
    
        setSelectedRows(prev => {
            const isSelected = prev.includes(id);
            const newSelected = isSelected ? prev.filter(x => x !== id) : [...prev, id];
    
            // Highlight ou clear selon la nouvelle valeur
            if (!isSelected) {
                DrawService.highlightEntityCollection(row);
            } else {
                DrawService.clearHighlight(row.id);
            }
    
            return newSelected;
        });
    };    

    const columns = [
        {
            key: 'group',
            sortable: false,
            width:'20px',
            label: (
                <input 
                className={genStyles.inputtCol}
                type="checkbox" 
                checked={allChecked} // état global
                onChange={() => toggleAllCheckboxes()} 
                />
            ),
            render: (_, row) => (
                <input 
                className={genStyles.inputtCol}
                type="checkbox" 
                checked={selectedRows.includes(row.id)} // état individuel
                onChange={() => toggleRowCheckbox(row.id)} 
                />
            )
        },
        {
            key: 'affiche',
            sortable: false,
            width:'20px',
            label: (
                <a onClick={() => toggleAll()} >
                    <TooltipForm content={`Afficher/Cacher les entités`}>
                    <i className={`${allOpen ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.maincolorfirsttext}`}></i>
                    </TooltipForm>
                </a>
            ),
            render: (_, row) => (
                <a onClick={(e) => {
                    e.preventDefault(); 
                    toggleOne(row , 'show');
                }}>
                    <TooltipForm content={`Afficher/Cacher l'entité`}>
                    <i  className={`${openFilesStates[row.id] ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.bgcolorfirsttext}`}></i>
                    </TooltipForm>
                </a>
            )
        },
        { key: 'titre', label: "Nom de l'entité", selectable: true},
        { 
            key: 'type', 
            label: "Type",
            selectable: true,
            width:'50px',
            render: (_, row) => {
                const typeInfo = typeFR[row.type];
                const parsedOptions = row?.geojson?.properties?.options;
                const color = parsedOptions?.color || parsedOptions?.icon?.options?.markerColor || '#000';
            
                return (
                <div className="cursor-pointer center-align">
                    <span style={{ color }}>
                    {typeInfo?.img}
                    </span>
                </div>
                );
            }
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            subColumns: [
                { key: 'action1', label: '' },
                { key: 'action2', label: '' },
                ],
            render: (_, row) =>  [
                <td key={`zoom-${row.id}`} style={{width:'20px'}}>
                    <a  onClick={() => zoomEntite(row)} >
                        <TooltipForm content={`Zoomer sur l'entité`}>
                            <i className={`fa-solid fa-magnifying-glass-plus yellow-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,

                <td key={`delete-${row.id}`} style={{ width: '20px' }}>
                <a onClick={() => deleteEntite(row)}>
                    <TooltipForm content={`Supprimer l'entité`}>
                    <i
                        className={`fa-solid fa-trash-can red-text text-darken-2 ${genStyles.fontSize16}`}
                    ></i>
                    </TooltipForm>
                </a>
                </td>,
            ]
        }
    ];

    const actionsbulk = [
        {
            icon: isVisible 
            ? <i className={`fa-solid fa-eye ${genStyles.fontSize18}`} />
            : <i className={`fa-solid fa-eye-slash ${genStyles.fontSize18}`} />,
            label: isVisible ? "Afficher les entités sélectionnées" : "Cacher les entités sélectionnées",
            onClick: () => toggleVisibility(),
            disabled: false,
        },
        {
            icon: <i className={`fa-solid fa-magnifying-glass-plus ${genStyles.fontSize18} yellow-text text-darken-3`} />,
            label: "Zoomer sur les entités sélectionnées",
            onClick:  () => zoomGlobal(),
            disabled: false,
        },
        {
            icon: <i className={`fa-solid fa-palette ${genStyles.fontSize18} blue-text text-darken-3`} />,
            label: "Éditer le style des entités sélectionnées",
            onClick: (e) => setStyleEntity(e),
            disabled: false,
        },
        {
            icon: <i className={`fa-solid fa-trash-can ${genStyles.fontSize18} red-text text-darken-2`} />,
            label: "Supprimer les entités sélectionnées",
            onClick: () => deleteGlobal(),
            disabled: false,
        }
    ];

    const toggleVisibility = () => {
        let selected = selectedRows;
        if (isVisible) {
            afficheGlobal(selected);  
        } else {
            cacherGlobal(selected);   
        }
        setIsVisible(!isVisible);  
    };

    const zoomGlobal = async() => {
        let selected = selectedRows;
        const selectedEntities = entitesFile.filter(e => selected.includes(e.id));
        const bounds = L.latLngBounds([]);
    
        for (const collection of selectedEntities) {
            const geojson = collection.geojson;
            const isOpen = openFilesStates[collection.id];
            if (!isOpen) {
                toggleOne(collection, 'zoom');
            }
        
            const layer = await ShowService.addEntitesToMap(geojson, 'show');
            if (layer[0] && layer[0].getBounds) {
                bounds.extend(layer[0].getBounds());
            } else if (layer[0] && layer[0].getLatLng) {
                bounds.extend(layer[0].getLatLng());
            }
        }
        
        if (bounds.isValid()) {
             DrawService.setZoomEmprise(bounds);
        }
        
        const selectedEntitiesplus = entitesFile.filter(e => selectedRows.includes(e.id));
        selectedEntitiesplus.forEach((item) => {
            DrawService.highlightEntity(item);
        });
        
    };

    const setStyleEntity = (event) => {
        let selected = selectedRows;
        const rect = event.currentTarget.getBoundingClientRect();
        setPopoverStyle({
            top: rect.bottom + window.scrollY + 5, 
            left: rect.left + window.scrollX,
        });
        const selectedEntities = entitesFile.filter(e => selected.includes(e.id));
        setShowStyleForm(true);
        setObjetCur(selectedEntities);
    };

    const deleteGlobal = () => {
        let selected = selectedRows;
        const selectedEntities = entitesFile.filter(e => selected.includes(e.id));
        setShowConfirmModalDeleteAll(true);
        setObjetCur(selectedEntities);
        
        const selectedEntitiesplus = entitesFile.filter(e => selectedRows.includes(e.id));
        selectedEntitiesplus.forEach((item) => {
            DrawService.highlightEntity(item);
        });
    };

    const afficheGlobal = (selected) => {
        const selectedEntities = entitesFile.filter(e => selected.includes(e.id));

        for (const collection of selectedEntities) {
            const geojson = collection.geojson;
            const isOpen = openFilesStates[collection.id];
            if (!isOpen) {
                toggleOne(collection, 'show');
            }
        }
        
    };

    const cacherGlobal = () => {
        let selected = selectedRows;
        const selectedEntities = entitesFile.filter(e => selected.includes(e.id));

        for (const collection of selectedEntities) {
            const geojson = collection.geojson;
            const isOpen = openFilesStates[collection.id];
            if (isOpen) {
                toggleOne(collection, 'show');
            }
        }
        
    };

    const toggleOne = (collection, type) => {
        const id = collection.id;
        setOpenFilesStates((prev) => {
            const isOpen = prev[id];
            const updated = { ...prev, [id]: !prev[id] };
            if(type === 'show'){
            // Action différente selon l'état
            if (isOpen) {
                hideCollection(collection);
            } else {
                showCollection(collection);
            }
            }         
            return updated;
        });
    };

    
    const hideCollection = (collection) => {
        DrawService.removeLayerCollection(collection,'entity');
        if (selectedRows.includes(collection.id)) {
            DrawService.clearHighlight(collection.id);
        }
    }

    const showCollection = (collection) => {
        const geojson = collection.geojson;
        ShowService.addEntitesToMap(geojson,'show');

        if (selectedRows.includes(collection.id)) {
            DrawService.highlightEntityCollection(collection);
        }
    };

    const toggleAllCheckboxes = () => {
        if (allChecked) {
            setSelectedRows([]); 
            DrawService.clearHighlight();
        } else {
            setSelectedRows(entitesFile.map(r => r.id));
            entitesFile.forEach((item) => {
                DrawService.highlightEntity(item);
            });
         
        }
    };

    const toggleRowCheckbox = (id) => {
        setSelectedRows(prev => {
            let updated;
            if (prev.includes(id)) {
                updated = prev.filter(x => x !== id);
                // si on décoche → on enlève le highlight
                DrawService.clearHighlight(id);
            } else {
                updated = [...prev, id];
                // highlight la dernière entité cochée
                const entity = entitesFile.find(e => e.id === id);
                if (entity) {
                    DrawService.highlightEntity(entity);
                }
            }
            return updated;
        });
    };

    const toggleAll = () => {
        const newState = !allOpen;
        setAllOpen(newState);
        
        const newOpenStates = {};
        entitesFile.forEach((item) => {
            newOpenStates[item.id] = newState;
            if(newState){
            showCollection(item);
            }else{
            hideCollection(item);
            }
        });
        setOpenFilesStates(newOpenStates);
    };
    
    const zoomEntite = (collection) => {
        const geojson = collection.geojson;
        const isOpen = openFilesStates[collection.id];
        if(!isOpen){
            toggleOne(collection, 'zoom');
        }
        ShowService.addEntitesToMap(geojson,'zoom');        
        if (selectedRows.includes(collection.id)) {
            DrawService.highlightEntityCollection(collection);
        }
    };

    const deleteEntite = (item) => {
        setShowConfirmModal(true);
        setObjetCur(item);
    };

    const annulerOp = () => {
        entitesFile.forEach((entity) => {
            const collection = { id: entity.id };
            DrawService.removeLayerCollection(collection, "entity");           
            DrawService.clearHighlight(entity.id);
        });
        setEntitesFile([]);
        setActiveTab(false);
    };

    const ValiderOp = () => {
        if (onValidateEntite) {
            onValidateEntite(entitesFile); 
        }   
    };

    return (
        <div className="row">
            <div className="col s12">
                <div>
                    <p className={`mb0 mt0 italic center-align ${genStyles.fontSize18}`}>Prévisualisation des données</p>
                </div>

                <div className="mt10 center-align" dangerouslySetInnerHTML={{ __html: messageAffiche }} ></div>
                
                <div className={`col s12 ${genStyles.genbackground}`}>
                    <ResultForm 
                    data={entitesFile} 
                    columns={columns} 
                    onSelectRow={selectAllDataRow} 
                    pageSize={100} 
                    tableHeight="500px" 
                    textpaginate="entités" 
                    texteSearch="Rechercher une entité"
                    sortConfig={sortConfigEntityFile}
                    setSortConfig={setSortConfigEntityFile}
                    searchQuery={searchQueryEntityFile}
                    setSearchQuery={setSearchQueryEntityFile}
                    currentPage={currentPageEntityFile}
                    setCurrentPage={setCurrentPageEntityFile}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    bulkActions={actionsbulk}
                    />
                </div>
                <div className={genStyles.buttonfooter} style={{marginTop:'15px'}}>
                        <button
                        className="btn red lighten-1 z-depth-0 mr5 ml5"
                        style={{ width: '120px' }}
                        onClick={annulerOp}
                        >
                        Annuler
                        </button>
                        {entitesFile.length > 0 && (
                        <button
                        className="btn green lighten-1 z-depth-0 mr5 ml5"
                        style={{ width: '120px' }}
                        onClick={ValiderOp}
                        >
                        Valider
                        </button>
                        )}
                </div>
            </div>


        
            {showStyleForm && (
                <div className={genStyles.modalsetstyle}>
                    <SetStyleForm onClose={() => setShowStyleForm(false)} objectCur={objetCur} setEntites={setEntitesFile} popoverStyle={popoverStyle} selectedRows={selectedRows} entitesFile={entitesFile}  />               
                </div>
            )}
            
            {showConfirmModalDeleteAll && (
                <FullScreenModal>
                    <DeleteCollectionForm onClose={() => setShowConfirmModalDeleteAll(false)} objectCur={objetCur} type='deleteallentityForFile' setEntites={setEntitesFile}/>
                </FullScreenModal>
            )}
            
            {showConfirmModal && (
                <FullScreenModal>
                    <DeleteCollectionForm onClose={() => setShowConfirmModal(false)} objectCur={objetCur} type='entityForFile' setEntites={setEntitesFile}/>
                </FullScreenModal>
            )}
        </div>
    );
}
